import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type PaymentCancellationId = Branded<string, "PaymentCancellationId">;
const paymentCancellationIdPrefix = "payment_cancellation__";
const {
    factory: paymentCancellationIdFactory,
    assert: isPaymentCancellationId,
    zodSchema: paymentCancellationIdZodSchema,
} = genericId<PaymentCancellationId>(paymentCancellationIdPrefix);

export {
    isPaymentCancellationId,
    paymentCancellationIdFactory,
    paymentCancellationIdPrefix,
    paymentCancellationIdZodSchema,
};

export type { PaymentCancellationId };
